import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Modal } from 'antd';
import { createUseStyles } from 'react-jss';
const useStyles = createUseStyles({
    baseModal: {
        '& .ant-modal-content .ant-modal-body': {
            maxHeight: 650,
            overflow: 'auto',
        },
    },
});
export const BaseModal = (props) => {
    const { cancelText, footerLeft, footerRight, onCancel, onOk, okText } = props;
    const styles = useStyles();
    const defaultFooterDoms = {
        cancel: _jsx(Button, { onClick: onCancel, children: cancelText || '取 消' }),
        ok: (_jsx(Button, { style: { marginLeft: '8px' }, type: "primary", onClick: () => onOk?.(), children: okText || '确 定' })),
    };
    return (_jsx(Modal, { className: styles.baseModal, footer: _jsxs("div", { style: {
                display: 'flex',
                justifyContent: footerLeft ? 'space-between' : 'end',
                alignItems: 'center',
            }, children: [footerLeft ? (_jsx("div", { style: { flex: 1, display: 'inline-grid' }, children: _jsx("div", { style: {
                            textAlign: 'left',
                            paddingRight: '50px',
                            width: '100%',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }, children: footerLeft }) })) : null, footerRight ? (footerRight({
                    defaultDoms: defaultFooterDoms,
                    onCancel,
                    onOk,
                })) : (_jsx("div", { children: Object.keys(defaultFooterDoms)?.map((domKey) => defaultFooterDoms[domKey]) }))] }), ...props, bodyStyle: {
            // padding: '0 24px 24px',
            ...(props.bodyStyle ?? {})
        } }));
};
